import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { motion, useReducedMotion } from "framer-motion";
import "./Hero.css";
import { useLocalContext } from "../../context/LocalContext";

const HERO_IMG =
  "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=2000&q=80";

const Hero = () => {
  const navigate = useNavigate();
  const { webinfo = {} } = useLocalContext();
  const reduceMotion = useReducedMotion();

  const brand = webinfo?.name || "smartprintersolutions.com";

  const enter = reduceMotion
    ? { opacity: 1, y: 0 }
    : { opacity: 0, y: 28 };

  const shown = { opacity: 1, y: 0 };

  return (
    <section className="hro" aria-labelledby="hero-heading">
      <div className="hro__media" aria-hidden="true">
        <motion.img
          src={HERO_IMG}
          alt=""
          className="hro__img"
          initial={reduceMotion ? false : { scale: 1.08 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
        />
        <div className="hro__veil" />
        <div className="hro__grain" />
      </div>

      <div className="hro__wrap">
        <motion.p
          className="hro__brand"
          initial={enter}
          animate={shown}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          {brand}
        </motion.p>

        <motion.h1
          id="hero-heading"
          className="hro__title"
          initial={enter}
          animate={shown}
          transition={{ duration: 0.75, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
        >
          Digital marketing that grows visibility—without the hype.
        </motion.h1>

        <motion.p
          className="hro__sub"
          initial={enter}
          animate={shown}
          transition={{ duration: 0.75, delay: 0.16, ease: [0.22, 1, 0.36, 1] }}
        >
          SEO, paid media, content, email, and analytics—planned in writing, measured honestly, and aligned with ad
          platform expectations.
        </motion.p>

        <motion.div
          className="hro__actions"
          initial={enter}
          animate={shown}
          transition={{ duration: 0.75, delay: 0.24, ease: [0.22, 1, 0.36, 1] }}
        >
          <button type="button" className="hro__btn hro__btn--primary" onClick={() => navigate("/contact")}>
            Request a consultation <FaArrowRight aria-hidden />
          </button>
          <button type="button" className="hro__btn hro__btn--ghost" onClick={() => navigate("/services")}>
            Explore services
          </button>
        </motion.div>

        <motion.p
          className="hro__fine"
          initial={enter}
          animate={shown}
          transition={{ duration: 0.7, delay: 0.32 }}
        >
          No guaranteed rankings or ROI.{" "}
          <Link to="/disclaimer">Disclaimer</Link> · <Link to="/privacy-policy">Privacy</Link>
        </motion.p>
      </div>
    </section>
  );
};

export default Hero;
